<template>
  <div>
    <b-navbar toggleable="lg" type="dark" class="mb-0">
      <b-navbar-brand class="brandA" href="#">
        <span class="brandA__firstword">Martin</span> Wong
        <p class="brand-desc">Luxury Vacation Rentals</p>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item>
            <router-link class="main-link" to="/">HOME</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link class="main-link" to="/about">ABOUT</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link class="main-link" to="/gallery">GALLERY</router-link>
          </b-nav-item>
          <b-nav-item-dropdown text="RENTALS" right>
            <b-dropdown-item><router-link class="dropdown-link" to="/villaandaluza">VILLA ANDALUZA</router-link></b-dropdown-item>
            <b-dropdown-item><router-link class="dropdown-link" to="/villaveranza">VILLA VERANZA</router-link></b-dropdown-item>
            <b-dropdown-item><router-link class="dropdown-link" to="/bluebay301">BLUE BAY 301</router-link></b-dropdown-item>
            <b-dropdown-item><router-link class="dropdown-link" to="/bluebay302">BLUE BAY 302</router-link></b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item>
            <router-link class="main-link" to="/contact">CONTACT</router-link>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../styles/main";
.brandA {
  text-align: left;
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  font-size: 28px!important;
  &__firstword{
    font-weight: 800;
  }
}
.brand-desc {
  text-align: left;
  margin-bottom: 0px;
  font-size: 16px;
  font-family: "Raleway", sans-serif;
}
nav {
  margin-bottom: 0px;
  .main-link {
    color: white !important;
  }
  .nav-link {
    color: white !important;
  }
  background-color: $bg--blue;
  margin-bottom: 40px;
  font-family: "Raleway", sans-serif;
  font-size: 16px;
  font-family: "Raleway", sans-serif;
  font-weight: 700;
  
  .dropdown-menu-right {
    border: 2px solid #bce0fd;
    a {
      color: $text--blue--dark;
      font-family: "Raleway", sans-serif;
      
    }
  }
}
</style>